export const getSelectedServiceTreeDetails = (services = []) =>
  services
    .filter(
      (service) =>
        service.isSelected ||
        service.reasons.some((reason) => reason.isSelected)
    )
    .map((service) => {
      const reasons = service.reasons.filter((reason) => reason.isSelected);

      return {
        ...service,
        reasons,
        reasonIds: reasons.map((reason) => reason.id),
        reasonNames: reasons.map((reason) => reason.name),
        allReasonIds: service.reasons.map((reason) => reason.id),
      };
    });
